export class FAQ {
	constructor() {
		this.container = document.querySelectorAll('.faq');
		this.questions = document.querySelectorAll('.faq-question');
	}

	init() {
		this.questions.forEach((question) => {
			question.addEventListener('click', () => {
				this.onClickQuestion(question);
			});
		});
	}

	onClickQuestion(question) {
		const isExpended = question.getAttribute('aria-expanded') === 'true';
		const elementToOpen = question.nextElementSibling;
		const heightTarget =
			elementToOpen.querySelector('.faq-answer').scrollHeight;

		elementToOpen.style.height = !isExpended ? `${heightTarget}px` : '0px';
		question.setAttribute('aria-expanded', !isExpended);
	}
}
